import { IoIosArrowRoundForward } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import bg_hero_section_2 from "../../../Assets/bg_hero_section_2.png";
import modelo_celular from "../../../Assets/modelo_celular.png";
import coins from "../../../Assets/coins.png";
import * as S from "./HeroSectionDesk.styles";
import { Fragment } from "react";

export const HeroSectionDesk = () => {
  const handleMenuClick = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="w-full hidden lg:block">
      <div className="h-[88px]"></div>
      <S.ParallaxContainer>
        <S.ParallaxBackground
          style={{
            backgroundImage: `url(${bg_hero_section_2})`,
            zIndex: "1",
          }}
        ></S.ParallaxBackground>

        <S.ParallaxContent>
          <S.ParallaxContentBox>
            <div className="flex flex-col">
              <S.ParallaxContentH5>Unlock Brazil’s</S.ParallaxContentH5>

              <S.ParallaxContentH1>$100B Digital Market</S.ParallaxContentH1>

              <S.ParallaxContentH5>- In Real Time</S.ParallaxContentH5>

              <S.ParallaxContentP>
                Launch your business in Brazil with real-time, PIX-powered
                payins — fast, secure, and 100% compliant.
              </S.ParallaxContentP>

              {/*<S.BtnBox>
                <S.Btn
                  onClick={() =>
                    window.open(
                      "https://wa.me/5541999920109?text=Hello%2C%20I%20would%20like%20more%20information.",
                      "_blank"
                    )
                  }
                  style={{
                    zIndex: "1",
                  }}
                  className="
                bg-[var(--lime-500)]
                text-[var(--lime-800)]
                hover:bg-[var(--marine-50)]
                hover:text-[var(--lime-500)]
              "
                >
                  Book a call teste
                  <IoIosArrowRoundForward size={24} />
                </S.Btn>

                <S.Btn
                  onClick={() =>
                    window.open(
                      "https://wa.me/5541999920109?text=Hello%2C%20I%20would%20like%20more%20information.",
                      "_blank"
                    )
                  }
                  style={{
                    zIndex: "1",
                  }}
                  className="
                border
                border-[var(--lime-500)]
                bg-[var(--marine-50)]
                text-[var(--lime-500)]
                hover:bg-[var(--lime-500)]
                hover:text-[var(--marine-50)]
              "
                >
                  Get Started teste
                </S.Btn>
              </S.BtnBox>*/}
            </div>

            <img
              src={coins}
              alt="coins"
              className="
                absolute
                h-[461.89px]
                w-[634.03px]
                right-[-75px]
              "
            />
          </S.ParallaxContentBox>

          <S.BtnOpportunityBox>
            <S.BtnOpportunity onClick={() => handleMenuClick("Opportunity")}>
              Explore the Opportunity
              <IoIosArrowDown size={24} />
            </S.BtnOpportunity>
          </S.BtnOpportunityBox>
        </S.ParallaxContent>

        <S.ParallaxImg
          style={{
            backgroundImage: `url(${modelo_celular})`,
            zIndex: 2,
            backgroundPosition: "54vw 200px",
            backgroundSize: "444px",
          }}
        ></S.ParallaxImg>
      </S.ParallaxContainer>
    </div>
  );
};
